/* Dar Al Huda Books: automatically include one Hajj & Umrah guide when two books are purchased.
   Shopify's existing automatic Buy X Get Y discount sets this guide to $0.
   The free copy is tagged as a private line item property so it can be removed
   automatically if the customer no longer qualifies. */
(function () {
  'use strict';

  if (window.DarAlHudaAutoGiftInitialized) return;
  window.DarAlHudaAutoGiftInitialized = true;

  const GIFT_VARIANT_ID = 49671034142977;
  const GIFT_PRODUCT_ID = 9238821568769;
  const GIFT_MARKER = '_dar_al_huda_auto_hajj_gift';
  const ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  const nativeFetch = window.fetch.bind(window);
  let timer = null;
  let pending = null;
  let repeat = false;

  function scheduleCheck(delay) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      void checkGift();
    }, typeof delay === 'number' ? delay : 180);
  }

  function isCartWrite(input, options) {
    try {
      const url = new URL(typeof input === 'string' ? input : input.url, window.location.href);
      const method = String((options && options.method) || (input && input.method) || 'GET').toUpperCase();
      return url.origin === window.location.origin &&
        method !== 'GET' &&
        /\/cart\/(?:add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname);
    } catch (_error) { return false; }
  }

  // Watch the theme's normal product and quantity updates. Gift requests use
  // nativeFetch directly and never trigger their own observers.
  window.fetch = function (input, options) {
    const watch = isCartWrite(input, options);
    const promise = nativeFetch.apply(null, arguments);
    if (watch) {
      promise.then(function (response) {
        if (response.ok) scheduleCheck(130);
      }).catch(function () {});
    }
    return promise;
  };

  function itemIsBook(item) {
    return String(item.product_type || '').toLowerCase() === 'books';
  }

  function isOurGift(item) {
    return Number(item.variant_id) === GIFT_VARIANT_ID &&
      item.properties &&
      String(item.properties[GIFT_MARKER]) === 'true';
  }

  async function getCart() {
    const response = await nativeFetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }

  async function postCart(endpoint, payload) {
    const response = await nativeFetch(ROOT + 'cart/' + endpoint + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!response.ok) throw new Error('Automatic gift change was rejected');
    return response.json();
  }

  async function updateVisibleCart() {
    try {
      const url = new URL(ROOT + 'cart', window.location.origin);
      url.searchParams.set('sections', 'cart-icon-bubble');
      const response = await nativeFetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' });
      if (response.ok) {
        const sections = await response.json();
        const bubbleHtml = sections['cart-icon-bubble'];
        if (bubbleHtml) {
          const doc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
          const next = doc.querySelector('#cart-icon-bubble');
          const current = document.querySelector('#cart-icon-bubble');
          if (current && next) current.innerHTML = next.innerHTML;
        }
      }
    } catch (error) {
      console.warn('Dar Al Huda: cart badge update unavailable', error);
    }

    try {
      const cartItems = document.querySelector('cart-drawer-items');
      if (cartItems && typeof cartItems.onCartUpdate === 'function') {
        await cartItems.onCartUpdate();
      }
    } catch (error) {
      console.warn('Dar Al Huda: cart drawer refresh unavailable', error);
    }

    // Cart page totals are rendered server-side; refresh after a gift changes.
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
    }
  }

  async function performCheck() {
    const cart = await getCart();
    const lines = cart.items || [];
    const autoGiftLines = lines.filter(isOurGift);
    const purchasedBookQuantity = lines.reduce(function (total, item) {
      return total + (itemIsBook(item) && !isOurGift(item) ? Number(item.quantity || 0) : 0);
    }, 0);
    const manuallyAddedGiftQuantity = lines.reduce(function (total, item) {
      return total + (Number(item.product_id) === GIFT_PRODUCT_ID && !isOurGift(item) ? Number(item.quantity || 0) : 0);
    }, 0);

    // An already-purchased guide can serve as the free third book if there
    // are at least three paid books in the cart (two qualifying + that guide).
    const manualGuideCanBeFree = manuallyAddedGiftQuantity > 0 && purchasedBookQuantity >= 3;
    const needsAutoGift = purchasedBookQuantity >= 2 && !manualGuideCanBeFree;

    if (needsAutoGift && autoGiftLines.length === 0) {
      await postCart('add', {
        items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { [GIFT_MARKER]: 'true' } }]
      });
      await updateVisibleCart();
    } else if (!needsAutoGift && autoGiftLines.length > 0) {
      for (const item of autoGiftLines) {
        await postCart('change', { id: item.key, quantity: 0 });
      }
      await updateVisibleCart();
    } else if (autoGiftLines.length > 0 &&
        autoGiftLines.some(function (item) { return Number(item.quantity) !== 1; })) {
      for (const item of autoGiftLines) {
        if (Number(item.quantity) !== 1) {
          await postCart('change', { id: item.key, quantity: 1 });
        }
      }
      await updateVisibleCart();
    }
  }

  async function checkGift() {
    if (pending) {
      repeat = true;
      return pending;
    }
    pending = performCheck().catch(function (error) {
      console.warn('Dar Al Huda: automatic Hajj gift could not be synced', error);
    }).finally(function () {
      pending = null;
      if (repeat) {
        repeat = false;
        scheduleCheck(140);
      }
    });
    return pending;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scheduleCheck(0); }, { once: true });
  } else {
    scheduleCheck(0);
  }
  window.addEventListener('pageshow', function () { scheduleCheck(100); });
  document.addEventListener('shopify:section:load', function () { scheduleCheck(100); });
})();
